import axios from 'axios';

const financeApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

financeApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('financeToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setFinanceToken = (token) => {
  if (token) {
    localStorage.setItem('financeToken', token);
  } else {
    localStorage.removeItem('financeToken');
  }
};

export const getFinanceToken = () => localStorage.getItem('financeToken');

export const clearFinanceAuth = () => {
  localStorage.removeItem('financeToken');
  localStorage.removeItem('financeUser');
};

export const setFinanceUser = (user) => {
  localStorage.setItem('financeUser', JSON.stringify(user));
};

export const getFinanceUser = () => {
  const raw = localStorage.getItem('financeUser');
  return raw ? JSON.parse(raw) : null;
};

export default financeApi;
